import { useState, useRef, useEffect } from "react";
import { useMessagesData } from "./useMessagesData";

export const useMessagesPagination = ({
  seen,
//   isSearching,
//   searchedValue,
  onLoading,
}) => {
  // cursor for pagination
  const [page, setPage] = useState(0);
  const cursorStack = useRef<number[]>([]);

  let { isQueryLoading, isIdle, error, messages, isPreviousData, refetch } =
    useMessagesData({
      page,
      seen,
      onLoading,
    });

  const { items, cursor, remaining } = messages || {};
  // console.log("items: ", items);
  const hasMore = messages?.remaining > 0;

  const resetPagination = (refresh?: boolean) => {
    setPage(0);
    cursorStack.current = [0];
    if (refresh) refetch();
  };

  const nextPagination = () => {
    if (!isPreviousData && hasMore) {
      const newPage = cursor;
      setPage(newPage);
      cursorStack.current = [...cursorStack.current, newPage];
    }
  };

  const previousPagination = () => {
    if (cursorStack.current.length <= 2) {
      resetPagination();
    } else {
      const temp = cursorStack.current.slice(0, -2);
      const newPage = temp[temp.length - 1];
      setPage(newPage);
      cursorStack.current = temp;
    }
  };

  return {
    messages,
    isQueryLoading,
    error,
    items,
    previousPagination,
    nextPagination,
    resetPagination,
    hasMore,
    remaining,
    page,
    isPreviousData,
  };
};
